import { mapGetters } from 'vuex';
import constants from '../constants/constants';
import sourceHanSansCnNormalUrl from '@/assets/css/common/fonts/Source_Han_Sans_CN_Normal.otf';

const SOURCE_HAN_SANS_CN_NAME = 'Source Han Sans CN Normal';
const SOURCE_HAN_SANS_CN_STACK = `"${SOURCE_HAN_SANS_CN_NAME}", sans-serif`;
const SOURCE_HAN_SANS_CN_STYLE_ID = 'source-han-sans-cn-normal-font-face';

function ensureCnFontFaceLoaded() {
  if (typeof document === 'undefined') return;

  if (!document.getElementById(SOURCE_HAN_SANS_CN_STYLE_ID)) {
    const style = document.createElement('style');
    style.id = SOURCE_HAN_SANS_CN_STYLE_ID;
    style.textContent = `
      @font-face {
        font-family: '${SOURCE_HAN_SANS_CN_NAME}';
        src: url('${sourceHanSansCnNormalUrl}') format('opentype');
        font-style: normal;
        font-weight: 400;
        font-display: swap;
      }
    `;
    document.head.appendChild(style);
  }

  if (document.fonts && document.fonts.load) {
    document.fonts.load(`1rem "${SOURCE_HAN_SANS_CN_NAME}"`);
  }
}

const commonPageMixins = {
  computed: {
    ...mapGetters(['getCurrentLanguage']),
  },
  watch: {
    getCurrentLanguage() {
      this.setFontFamily();
    },
  },
  created() {
    this.setFontFamily();
  },
  methods: {
    setCnFontVariables() {
      document.documentElement.style.setProperty('--font-family-osawald', SOURCE_HAN_SANS_CN_STACK);
      document.documentElement.style.setProperty('--font-family-not-found-page', SOURCE_HAN_SANS_CN_STACK);
      document.documentElement.style.setProperty('--font-family-noto-sans-jp', SOURCE_HAN_SANS_CN_STACK);
      document.documentElement.style.setProperty('--font-family-helvetica-arial', SOURCE_HAN_SANS_CN_STACK);
      document.documentElement.style.setProperty('--font-family-sans-serif', SOURCE_HAN_SANS_CN_STACK);
      document.documentElement.style.setProperty('--font-family-helvetica-neue-helvetica-arial', SOURCE_HAN_SANS_CN_STACK);
      document.documentElement.style.setProperty('--font-family-menlo-monaco-consolas-courier-new', SOURCE_HAN_SANS_CN_STACK);
      document.documentElement.style.setProperty('--font-family-common', SOURCE_HAN_SANS_CN_STACK);
      document.documentElement.style.setProperty('--font-family-comfortaa-cursive', SOURCE_HAN_SANS_CN_STACK);
      document.documentElement.style.setProperty('--font-family-montserrat', SOURCE_HAN_SANS_CN_STACK);
      document.documentElement.style.setProperty('--font-family-arial', SOURCE_HAN_SANS_CN_STACK);
      document.documentElement.style.setProperty('--font-family-roboto', SOURCE_HAN_SANS_CN_STACK);
      document.documentElement.style.setProperty('--font-family-kosugi', SOURCE_HAN_SANS_CN_STACK);
    },
    setDefaultFontVariables() {
      document.documentElement.style.setProperty('--font-family-osawald', '"Oswald",sans-serif');
      document.documentElement.style.setProperty('--font-family-not-found-page', '"メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", sans-serif');
      document.documentElement.style.setProperty('--font-family-noto-sans-jp', '"Noto Sans JP", sans-serif');
      document.documentElement.style.setProperty('--font-family-helvetica-arial', 'Helvetica, Arial, sans-serif');
      document.documentElement.style.setProperty('--font-family-sans-serif', 'sans-serif');
      document.documentElement.style.setProperty('--font-family-helvetica-neue-helvetica-arial', '"Helvetica Neue", Helvetica, Arial, sans-serif');
      document.documentElement.style.setProperty('--font-family-menlo-monaco-consolas-courier-new', 'Menlo, Monaco, Consolas, "Courier New", monospace');
      document.documentElement.style.setProperty('--font-family-common', '"ヒラギノ角ゴ Pro W3","Hiragino Kaku Gothic Pro","メイリオ","Meiryo","ＭＳ Ｐゴシック","MS PGothic","游ゴシック","Yu Gothic",YuGothic,sans-serif');
      document.documentElement.style.setProperty('--font-family-comfortaa-cursive', '"Comfortaa", cursive');
      document.documentElement.style.setProperty('--font-family-montserrat', '"Montserrat", sans-serif');
      document.documentElement.style.setProperty('--font-family-arial', 'Arial,sans-serif');
      document.documentElement.style.setProperty('--font-family-roboto', '"Roboto", sans-serif');
      document.documentElement.style.setProperty('--font-family-kosugi', '"Kosugi",sans-serif');
    },
    setFontFamily() {
      if (this.getCurrentLanguage === constants.LANGUAGE_CN) {
        ensureCnFontFaceLoaded();
        this.setCnFontVariables();
      } else {
        this.setDefaultFontVariables();
      }
    },
  },
};

export default commonPageMixins;
